import { render, staticRenderFns } from "./MailingAuth.vue?vue&type=template&id=42996806&lang=pug"
import script from "./MailingAuth.vue?vue&type=script&lang=js"
export * from "./MailingAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports